const $ = require('jquery');

module.exports = function ($window, $state, $timeout) {
    return {
        restrict: 'E',
        scope: {
            // loading variable
            loading: '=?',
            spinnerClass: '@?',
            browserBack: '='
        },
        link(scope) {
            const redirectToProperState = function () {
                if ($state.includes('shop.browse')) {
                    $state.go('shop.browse');
                } else if ($state.includes('shop.search')) {
                    $state.go('shop.search');
                } else if ($state.includes('shop.specials.browse')) {
                    $state.go('shop.specials.browse');
                } else if ($state.includes('shop.specials.groups')) {
                    $state.go('shop.specials.groupsv2');
                } else if ($state.includes('shop.inspiration.parent')) {
                    $state.go('shop.inspiration', { parent: $state.params.parent });
                } else if ($state.includes('shop.inspiration.parent.child')) {
                    $state.go('shop.inspiration.parent', { parent: $state.params.parent });
                } else if ($state.includes('shop.list')) {
                    $state.go('shop.list');
                } else if ($state.includes('shop.guestList')) {
                    $state.go('shop.guestList');
                } else if ($state.includes('shop.recipes')) {
                    $state.go('shop.recipes');
                } else if ($state.includes('shop.productdetails')) {
                    $state.go('shop.browse');
                } else if ($state.includes('shop.recipedetail')) {
                    $state.go('shop.recipes');
                } else if ($state.includes('shop.productgroup')) {
                    $state.go('shop.browse');
                } else if ($state.includes('shop.new')) {
                    $state.go('shop.browse');
                }
            };

            scope.onClick = function (event) {

                if (scope.browserBack) {
                    event.preventDefault();

                    $window.history.back();
                } else {
                    redirectToProperState();
                }
            };

            function mimicStickyHeaderHeight() {
                $timeout(function () {
                    const actualHeight = $('.olyStickyHeaderWithText').outerHeight(true);
                    $('.backButton-container').css('margin-top', actualHeight + 'px');
                }, 0, false);
            }

            scope.$on('$stateChangeSuccess', mimicStickyHeaderHeight);

            mimicStickyHeaderHeight();
        },
        template: require('./back-button-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/button/back-button-directive.js
 **/